export default __webpack_public_path__ + "97fdce269e0cb65eb232e9aa6db0e64b.png";